import { IconWrapper } from '../runtime';
export default IconWrapper('qq-sharing-one', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "fill": "none",
      "height": props.size,
      "viewBox": "0 0 48 48",
      "width": props.size
    }
  }, [h("linearGradient", {
    "attrs": {
      "id": props.id + 'edaad125',
      "gradientUnits": "userSpaceOnUse",
      "x1": "-24",
      "x2": "24",
      "y1": "24",
      "y2": "72"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "#0fb9f5"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#0ca9f3"
    }
  })]), h("circle", {
    "attrs": {
      "cx": "24",
      "cy": "24",
      "fill": 'url(#' + props.id + 'edaad125' + ')',
      "r": "24"
    }
  }), h("path", {
    "attrs": {
      "clip-rule": "evenodd",
      "d": "m33.31 26.5353c-.4755-1.542-1.0223-2.8379-1.8634-4.9588.1308-5.5707-2.1636-10.0765-7.4479-10.0765-5.3437 0-7.5875 4.5958-7.4449 10.0765-.844 2.1239-1.3879 3.4108-1.8634 4.9588-1.0105 3.2848-.6836 4.6437-.4339 4.6737.5349.066 2.0833-2.4718 2.0833-2.4718 0 1.4699.749 3.3868 2.3717 4.7697-.7846.243-2.547.897-2.128 1.6139.3389.579 5.8311.369 7.4152.189 1.5841.18 7.0764.39 7.4152-.189.4191-.7139-1.3463-1.3709-2.128-1.6139 1.6228-1.3859 2.3717-3.3028 2.3717-4.7697 0 0 1.5484 2.5378 2.0834 2.4718.2526-.033.5795-1.3919-.431-4.6737z",
      "fill": "#fff",
      "fill-rule": "evenodd"
    }
  })]);
});